export default "__VITE_ASSET__Czop34hK__"